"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLayoutProps = void 0;
const useMediaQuery_1 = require("./useMediaQuery");
function useLayoutProps() {
    const isScreenSmall = useMediaQuery_1.useMediaQuery('(max-width: 900px)');
    return {
        isMenuToggleVisible: isScreenSmall,
        isMenuOpen: true,
    };
}
exports.useLayoutProps = useLayoutProps;
//# sourceMappingURL=useLayoutProps.js.map